import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LazyImgDirective } from '../../directives/lazy-img.directive';

@Component({
    selector: 'app-token-banner',
    standalone: true,
    imports: [LazyImgDirective],
    templateUrl: './token-banner.component.html',
    styleUrls: ['./token-banner.component.scss']
})
export class TokenBannerComponent {
    CDN = environment.CDN_URL;
    IXFI_TOKEN = environment.IXFI_TOKEN;
}
